import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { DataEntity_Detail_01_Interface, Empty_DataEntity_Detail_01_Interface } from 'src/app/Interface/DataEntity/01/DataEntity_Detail_01_Interface';
import { DataEntity_Main_01_Interface, Empty_DataEntity_Main_01_Interface } from 'src/app/Interface/DataEntity/01/DataEntity_Main_01_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { DataEntity01Service } from 'src/app/Service/DataEntity/01/DataEntity01.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-DataEntity01',
  templateUrl: './DataEntity01.component.html',
  styleUrls: ['./DataEntity01.component.scss']
})
export class DataEntity01Component implements OnInit {

  constructor(
    private Calibration_Service: CalibrationService,
    private DataEntity01_Service: DataEntity01Service,
    private DataEntityMain_Service: DataEntityMainService,
    private Alerify_Service: AlertifyService,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) { }

  Token: String = ""
  FileName: string = ""
  Uncertainty_Value_List:Array<String>=[]
  CertificateCode: String = ""
  InProccessing: boolean = false;
  Calibration_Device_Id: number = 0
  Calibration_Device: Calibration_Interface = Empty_Calibration_Interface()
  BaseUrl = environment.BaseUrl + "Certificateno01/Show?id="

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');




    this.MainFormDataEntity = new FormGroup({
      id: new FormControl(),
      Reference_Value: new FormControl(null, Validators.required),
      Set_Value: new FormControl(null, Validators.required),
      Sample_Indication_Max: new FormControl(null, Validators.required),
      Sample_Indication_Min: new FormControl(null, Validators.required),
      Reference_Value_Center_Max: new FormControl(null, Validators.required),
      Reference_Value_Center_Min: new FormControl(null, Validators.required)
    })

    this.DetailFormDataEntity = new FormGroup({
      id: new FormControl(),
      Reference_Value_Position_Max: new FormControl(null, Validators.required),
      Reference_Value_Position_Min: new FormControl(null, Validators.required)
    })

    this.Calibration_Device_Id = Number(this.route.snapshot.paramMap.get('id'))
    this.Calibration_Service.GetSingleCalibrationDetail(this.Token, this.Calibration_Device_Id).subscribe(
      data => {
        this.Calibration_Device = data
        this.OnIntial()
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )

  }

  OnIntial() {
    this.DataEntity01_Service.GetSingle(this.Token, this.Calibration_Device_Id).subscribe(
      data => {
        this.BaseUrl = environment.BaseUrl + "Certificateno01/Show?id=" + data['qrcode'];

        this.MainDataEntity_List = data['result']

        for (let item of this.MainDataEntity_List)
        {
          this.Uncertainty_Value_List.push(item.uncertainty)
        }

        this.UploadImageSrc_List = data['image']
        this.canAdd_SubmitDATEOFISSUE_Date = data['canAdd_SubmitDATEOFISSUE_Date']
        this.SubmitDATEOFISSUE_Date = data['certificate_Code']['date_of_issue']

        this.CertificateCode = data['certificate_Code']
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#region Main Data Entity

  MainFormDataEntity: FormGroup
  Edit_Set_Value_List_Index:number=-1
  MainDataEntity_List: Array<DataEntity_Main_01_Interface> = []

  get_Form_Reference_Value() {
    return this.MainFormDataEntity.get('Reference_Value') as FormControl;
  }
  get_Form_Set_Value() {
    return this.MainFormDataEntity.get('Set_Value') as FormControl;
  }
  get_Form_Sample_Indication_Max() {
    return this.MainFormDataEntity.get('Sample_Indication_Max') as FormControl;
  }
  get_Form_Sample_Indication_Min() {
    return this.MainFormDataEntity.get('Sample_Indication_Min') as FormControl;
  }
  get_Form_Reference_Value_Center_Max() {
    return this.MainFormDataEntity.get('Reference_Value_Center_Max') as FormControl;
  }
  get_Form_Reference_Value_Center_Min() {
    return this.MainFormDataEntity.get('Reference_Value_Center_Min') as FormControl;
  }

  MainFormDataEntity_Submit() {
    var temp: DataEntity_Main_01_Interface = Empty_DataEntity_Main_01_Interface()
    temp.reference_Value = Number(this.get_Form_Reference_Value().value)
    temp.set_Value = Number(this.get_Form_Set_Value().value)
    temp.sample_Indication_Max = Number(this.get_Form_Sample_Indication_Max().value)
    temp.sample_Indication_Min = Number(this.get_Form_Sample_Indication_Min().value)
    temp.reference_Value_Center_Max = Number(this.get_Form_Reference_Value_Center_Max().value)
    temp.reference_Value_Center_Min = Number(this.get_Form_Reference_Value_Center_Min().value)
    temp.detail = this.DetailDataEntity_List

    if (this.Edit_Set_Value_List_Index == -1) {
      temp.id = 0

      this.MainDataEntity_List.push(temp)
      this.Alerify_Service.SuccessMessage("Added to the table.")


    }
    else {
      temp.id = this.MainDataEntity_List[this.Edit_Set_Value_List_Index].id

      this.MainDataEntity_List[this.Edit_Set_Value_List_Index]=temp
      this.Alerify_Service.SuccessMessage("Updated successfully.")
    }

    this.DetailDataEntity_List = []
    this.MainFormDataEntity.reset()
    this.Edit_Set_Value_List_Index = -1
  }

  MainDataEntity_List_Delete(id: number) {
    this.MainDataEntity_List.splice(id, 1)
    this.Alerify_Service.SuccessMessage("Deleted successfully.")
  }

  observation_visible_Value_List(id: number) {
    this.MainDataEntity_List[id].observation_visible = !this.MainDataEntity_List[id].observation_visible;
  }

  Edit_Set_Value_List(id: number)
  {
    this.Edit_Set_Value_List_Index = id
    var temp =  this.MainDataEntity_List[this.Edit_Set_Value_List_Index]

    this.get_Form_Reference_Value().setValue(temp.reference_Value)
    this.get_Form_Set_Value().setValue(temp.set_Value)

    this.get_Form_Sample_Indication_Max().setValue(temp.sample_Indication_Max)
    this.get_Form_Sample_Indication_Min().setValue(temp.sample_Indication_Min)

    this.get_Form_Reference_Value_Center_Max().setValue(temp.reference_Value_Center_Max)
    this.get_Form_Reference_Value_Center_Min().setValue(temp.reference_Value_Center_Min)


    this.DetailDataEntity_List = temp.detail
  }

  //#endregion

  //#region Detail Data Entity

  DetailFormDataEntity: FormGroup

  DetailDataEntity_List: Array<DataEntity_Detail_01_Interface> = []

  get_Form_Reference_Value_Position_Max() {
    return this.DetailFormDataEntity.get('Reference_Value_Position_Max') as FormControl;
  }
  get_Form_Reference_Value_Position_Min() {
    return this.DetailFormDataEntity.get('Reference_Value_Position_Min') as FormControl;
  }

  DetailFormDataEntity_Submit() {

    if (this.get_Form_Reference_Value_Position_Max().value < this.get_Form_Reference_Value_Position_Min().value) {
      this.Alerify_Service.ErrorMessage("Check the reference value positions.")
    }
    else {
      var temp: DataEntity_Detail_01_Interface = Empty_DataEntity_Detail_01_Interface()
      temp.id = 0
      temp.reference_Value_Position_Max = Number(this.get_Form_Reference_Value_Position_Max().value)
      temp.reference_Value_Position_Min = Number(this.get_Form_Reference_Value_Position_Min().value)

      this.DetailDataEntity_List.push(temp)
      this.Alerify_Service.SuccessMessage("Added to the table.")

      this.DetailFormDataEntity.reset()
    }
  }

  DetailDataEntity_List_Delete(id: number) {
    this.DetailDataEntity_List.splice(id, 1)
    this.Alerify_Service.SuccessMessage("Deleted successfully.")
  }

  //#endregion


  //#region Image
  UploadImageSrc_List: Array<string> = []
  UploadImageSrc: string = ''
  InProccessing_Image1: boolean = false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1 = true

    this.DataEntityMain_Service.uploadFile(formData).subscribe(
      data => {
        this.InProccessing_Image1 = false
        if (data['id'] == 0) {
          this.Alerify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alerify_Service.SuccessMessage("The file was uploaded successfully.")
          this.UploadImageSrc = data['filename']
        }
      }
    )

  }

  Remove_uploadImage1() {
    this.UploadImageSrc = ''
  }

  Add_uploadImage1() {
    this.UploadImageSrc_List.push(this.UploadImageSrc)
    this.UploadImageSrc = ''
    this.Alerify_Service.SuccessMessage("Added to the table.")
  }

  UploadImageSrc_List_Delete(id: number) {
    this.UploadImageSrc_List.splice(id, 1)
    this.Alerify_Service.SuccessMessage("Deleted successfully.")
  }

  //#endregion

  //#region Upload

    Procssing_Import:boolean=false
    upload_file_excel(files) {
      if (files.length === 0)
        return;

      const formData = new FormData();

      for (const file of files) {
        formData.append(file.name, file);
      }

      this.Procssing_Import=true

      this.DataEntity01_Service.uploadFile(formData,this.Token).subscribe(
        data => {

          this.Procssing_Import=false
          if(data['dsc'])
          {
            this.Alerify_Service.ErrorMessage(data['dsc'])
          }
          else {
            this.Uncertainty_Value_List=[]
            this.Alerify_Service.SuccessMessage("The information was loaded successfully.")

            this.FileName = data['filename']

            for (let item of data['nominal'])
            {
              this.Uncertainty_Value_List.push(item)
            }

          }
        }
      )

    }


    //#endregion


  modalRef_Code: any;

  onSubmit(template: TemplateRef<any>) {



    if (this.Uncertainty_Value_List.length != this.MainDataEntity_List.length) {
      this.Alerify_Service.ErrorMessage("The number of set values does not match the number of uncertainty values.")
      this.Alerify_Service.ErrorMessage("Uncertainty value count: " + this.Uncertainty_Value_List.length + ".")
    }
    else {
      this.InProccessing = true
      this.DataEntity01_Service.Submit(
        this.MainDataEntity_List,
        this.UploadImageSrc_List,
        this.Uncertainty_Value_List,
        this.Calibration_Device_Id,
        this.FileName,
        this.Token).subscribe(
          data => {
            this.InProccessing = false
            if (data['certificate_Code'] == '') {
              this.Alerify_Service.ErrorMessage("System error.")
            }
            else {
              this.BaseUrl = environment.BaseUrl + "Certificateno01/Show?id=" + data['qrcode'];
              this.CertificateCode = data['certificate_Code']
              this.Alerify_Service.SuccessMessage("The information was saved successfully.")

              this.modalRef_Code = this.modalService.show(template);
            }
          }
        )

    }

  }

  SubmitDATEOFISSUE_Date: string = ''
  canAdd_SubmitDATEOFISSUE_Date: boolean = false
  onSubmitDATEOFISSUE() {

    if (!this.SubmitDATEOFISSUE_Date || this.SubmitDATEOFISSUE_Date == undefined) {
      this.Alerify_Service.ErrorMessage("Enter the date.")
    }
    else {
      this.DataEntityMain_Service.SubmitDateOfIssue(this.Calibration_Device_Id, this.Token, this.SubmitDATEOFISSUE_Date).subscribe(
        data => {
          this.Alerify_Service.SuccessMessage("The information was saved successfully.")
        }
      )
    }

  }

}
